import axios from 'axios';

const api = axios.create({
    baseURL: 'https://seguranca-da-mulher.herokuapp.com/',
});

export default api;